import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken, getOwnerAccessToken } from "../../utils/auth";
import { Owner } from "../../types/modules/admin/Owner";

export const useCurrentOnwer = (ownerId?: number) => {
  const token = ownerId ? getAdminAccessToken() : getOwnerAccessToken();
  const endPoint = ownerId
    ? `owner/current?ownerId=${ownerId}`
    : "owner/current";
  return useQuery({
    queryKey: ["current-owner", ownerId],
    queryFn: () => fetcher<Owner>(endPoint, token),
  });
};
